import React from 'react';

function NoticePeriodField() {
  return '';
}

export default NoticePeriodField;
